import React from 'react';
import { Card, CardContent } from "./ui/card"
import { cn } from "../lib/utils"

const StatCard = ({
    icon,
    title,
    value,
    className,
    onClick,
    loading = false,
}) => {
    return (
        <Card
            className={cn(
                "transition-all duration-200 hover:shadow-md",
                onClick && "cursor-pointer hover:-translate-y-1",
                className
            )}
            onClick={onClick}
        >
            <CardContent className="p-6 flex items-center gap-4">
                <div className={cn(
                    "flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary",
                    "border border-primary/20"
                )}>
                    {React.cloneElement(icon, { className: "h-6 w-6" })}
                </div>

                <div className="flex-1">
                    {loading ? (
                        <div className="h-6 w-16 bg-muted animate-pulse rounded mb-1"></div>
                    ) : (
                        <div className="text-2xl font-bold tracking-tight text-gray-900">
                            {value}
                        </div>
                    )}
                    <div className="text-sm font-medium text-muted-foreground">
                        {title}
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};

export default StatCard;
